/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'

function ShopFilterGrid() {
  return (
    <>
      
<div className="breadcrumb-area pt-35 pb-35 bg-gray-3">
    <div className="container">
        <div className="breadcrumb-content text-center">
            <ul>
                <li>
                    <a href="index.html">Home</a>
                </li>
                <li className="active">Shop </li>
            </ul>
        </div>
    </div>
</div>
<div className="shop-area pt-95 pb-100">
    <div className="container">
        <div className="row flex-row-reverse">
            <div className="col-lg-12">
                <div className="shop-top-bar mb-35">
                    <div className="select-shoing-wrap">
                        <div className="shop-select">
                            <select>
                                <option value="">Sort by newness</option>
                                <option value="">A to Z</option>
                                <option value=""> Z to A</option>
                                <option value="">In stock</option>
                            </select>
                        </div>
                        <p>Showing 1–12 of 20 result</p>
                    </div>
                    <div className="filter-active">
                        <a href="#"><i className="fa fa-plus"></i> filter</a>
                    </div>
                </div>
                <div className="product-filter-wrapper">
                    <div className="row">
                        {/* <!-- Product Filter --> */}
                        <div className="col-md-3 col-sm-6 col-xs-12 mb-30">
                            <div className="product-filter">
                                <h5>Sort by</h5>
                                <ul className="sort-by">
                                    <li><a href="#">Default</a></li>
                                    <li><a href="#">Popularity</a></li>
                                    <li><a href="#">Average rating</a></li>
                                    <li><a href="#">Newness</a></li>
                                    <li><a href="#">Price: Low to High</a></li>
                                    <li><a href="#">Price: High to Low</a></li>
                                </ul>
                            </div>
                        </div>
                        {/* <!-- Product Filter --> */}
                        <div className="col-md-3 col-sm-6 col-xs-12 mb-30">
                            <div className="product-filter">
                                <h5>color filters</h5>
                                <ul className="color-filter">
                                    <li><input type="checkbox" value="" /> <a href="#">Black</a></li>
                                    <li><input type="checkbox" value="" /> <a href="#">Brown</a></li>
                                    <li><input type="checkbox" value="" /> <a href="#">Orange</a></li>
                                    <li><input type="checkbox" value="" /> <a href="#">red</a></li>
                                    <li><input type="checkbox" value="" /> <a href="#">Yellow</a></li>
                                    <li><input type="checkbox" value="" /> <a href="#">purple</a></li>
                                </ul>
                            </div>
                        </div>
                        {/* <!-- Product Filter --> */}
                        <div className="col-md-3 col-sm-6 col-xs-12 mb-30">
                            <div className="product-filter">
                                <h5>product tags</h5>
                                <div className="product-tags">
                                    <ul>
                                        <li><a href="#">New</a></li>
                                        <li><a href="#">brand</a></li>
                                        <li><a href="#">black</a></li>
                                        <li><a href="#">white</a></li>
                                        <li><a href="#">chire</a></li>
                                        <li><a href="#">table</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* <!-- Product Filter --> */}
                        <div className="col-md-3 col-sm-6 col-xs-12 mb-30">
                            <div className="product-filter">
                                <h5>Filter by price</h5>
                                <div className="price-filter mt-25">
                                    <div className="price-slider-amount">
                                        <input type="text" id="amount" name="price"  placeholder="Add Your Price" />
                                    </div>
                                    <div id="slider-range"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="shop-bottom-area">
                    <div className="row">
                        <div className="col-xl-4 col-md-6 col-lg-4 col-sm-6">
                            <div className="product-wrap mb-25 scroll-zoom">
                                <div className="product-img">
                                    <a href="product-details.html">
                                        <img className="default-img" src="assets/img/product/pro-1.jpg" alt="" />
                                        <img className="hover-img" src="assets/img/product/pro-1-1.jpg" alt="" />
                                    </a>
                                    <span className="pink">-10%</span>
                                    <div className="product-action">
                                        <div className="pro-same-action pro-wishlist">
                                            <a title="Wishlist" href="#"><i className="pe-7s-like"></i></a>
                                        </div>
                                        <div className="pro-same-action pro-cart">
                                            <a title="Add To Cart" href="#"><i className="pe-7s-cart"></i> Add to cart</a>
                                        </div>
                                        <div className="pro-same-action pro-quickview">
                                            <a title="Quick View" href="#" data-bs-toggle="modal" data-bs-target="#exampleModal"><i className="pe-7s-look"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="product-content text-center">
                                    <h3><a href="product-details.html">T- Shirt And Jeans</a></h3>
                                    <div className="product-rating">
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o"></i>
                                        <i className="fa fa-star-o"></i>
                                    </div>
                                    <div className="product-price">
                                        <span>$ 60.00</span>
                                        <span className="old">$ 60.00</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-lg-4 col-sm-6">
                            <div className="product-wrap mb-25 scroll-zoom">
                                <div className="product-img">
                                    <a href="product-details.html">
                                        <img className="default-img" src="assets/img/product/pro-2.jpg" alt="" />
                                        <img className="hover-img" src="assets/img/product/pro-2-1.jpg" alt="" />
                                    </a>
                                    <span className="purple">New</span>
                                    <div className="product-action">
                                        <div className="pro-same-action pro-wishlist">
                                            <a title="Wishlist" href="#"><i className="pe-7s-like"></i></a>
                                        </div>
                                        <div className="pro-same-action pro-cart">
                                            <a title="Add To Cart" href="#"><i className="pe-7s-cart"></i> Add to cart</a>
                                        </div>
                                        <div className="pro-same-action pro-quickview">
                                            <a title="Quick View" href="#" data-bs-toggle="modal" data-bs-target="#exampleModal"><i className="pe-7s-look"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="product-content text-center">
                                    <h3><a href="product-details.html">T- Shirt And Jeans</a></h3>
                                    <div className="product-rating">
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o"></i>
                                        <i className="fa fa-star-o"></i>
                                    </div>
                                    <div className="product-price">
                                        <span>$ 60.00</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-lg-4 col-sm-6">
                            <div className="product-wrap mb-25 scroll-zoom">
                                <div className="product-img">
                                    <a href="product-details.html">
                                        <img className="default-img" src="assets/img/product/pro-3.jpg" alt="" />
                                        <img className="hover-img" src="assets/img/product/pro-3-1.jpg" alt="" />
                                    </a>
                                    <span className="pink">-10%</span>
                                    <div className="product-action">
                                        <div className="pro-same-action pro-wishlist">
                                            <a title="Wishlist" href="#"><i className="pe-7s-like"></i></a>
                                        </div>
                                        <div className="pro-same-action pro-cart">
                                            <a title="Add To Cart" href="#"><i className="pe-7s-cart"></i> Add to cart</a>
                                        </div>
                                        <div className="pro-same-action pro-quickview">
                                            <a title="Quick View" href="#" data-bs-toggle="modal" data-bs-target="#exampleModal"><i className="pe-7s-look"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="product-content text-center">
                                    <h3><a href="product-details.html">T- Shirt And Jeans</a></h3>
                                    <div className="product-rating">
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o"></i>
                                        <i className="fa fa-star-o"></i>
                                    </div>
                                    <div className="product-price">
                                        <span>$ 60.00</span>
                                        <span className="old">$ 60.00</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-lg-4 col-sm-6">
                            <div className="product-wrap mb-25 scroll-zoom">
                                <div className="product-img">
                                    <a href="product-details.html">
                                        <img className="default-img" src="assets/img/product/pro-4.jpg" alt="" />
                                        <img className="hover-img" src="assets/img/product/pro-4-1.jpg" alt="" />
                                    </a>
                                    <span className="purple">New</span>
                                    <div className="product-action">
                                        <div className="pro-same-action pro-wishlist">
                                            <a title="Wishlist" href="#"><i className="pe-7s-like"></i></a>
                                        </div>
                                        <div className="pro-same-action pro-cart">
                                            <a title="Add To Cart" href="#"><i className="pe-7s-cart"></i> Add to cart</a>
                                        </div>
                                        <div className="pro-same-action pro-quickview">
                                            <a title="Quick View" href="#" data-bs-toggle="modal" data-bs-target="#exampleModal"><i className="pe-7s-look"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="product-content text-center">
                                    <h3><a href="product-details.html">T- Shirt And Jeans</a></h3>
                                    <div className="product-rating">
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o"></i>
                                        <i className="fa fa-star-o"></i>
                                    </div>
                                    <div className="product-price">
                                        <span>$ 60.00</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-lg-4 col-sm-6">
                            <div className="product-wrap mb-25 scroll-zoom">
                                <div className="product-img">
                                    <a href="product-details.html">
                                        <img className="default-img" src="assets/img/product/pro-5.jpg" alt="" />
                                        <img className="hover-img" src="assets/img/product/pro-5-1.jpg" alt="" />
                                    </a>
                                    <span className="pink">-10%</span>
                                    <div className="product-action">
                                        <div className="pro-same-action pro-wishlist">
                                            <a title="Wishlist" href="#"><i className="pe-7s-like"></i></a>
                                        </div>
                                        <div className="pro-same-action pro-cart">
                                            <a title="Add To Cart" href="#"><i className="pe-7s-cart"></i> Add to cart</a>
                                        </div>
                                        <div className="pro-same-action pro-quickview">
                                            <a title="Quick View" href="#" data-bs-toggle="modal" data-bs-target="#exampleModal"><i className="pe-7s-look"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="product-content text-center">
                                    <h3><a href="product-details.html">T- Shirt And Jeans</a></h3>
                                    <div className="product-rating">
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o"></i>
                                        <i className="fa fa-star-o"></i>
                                    </div>
                                    <div className="product-price">
                                        <span>$ 60.00</span>
                                        <span className="old">$ 60.00</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-lg-4 col-sm-6">
                            <div className="product-wrap mb-25 scroll-zoom">
                                <div className="product-img">
                                    <a href="product-details.html">
                                        <img className="default-img" src="assets/img/product/pro-6.jpg" alt="" />
                                        <img className="hover-img" src="assets/img/product/pro-6-1.jpg" alt="" />
                                    </a>
                                    <span className="purple">New</span>
                                    <div className="product-action">
                                        <div className="pro-same-action pro-wishlist">
                                            <a title="Wishlist" href="#"><i className="pe-7s-like"></i></a>
                                        </div>
                                        <div className="pro-same-action pro-cart">
                                            <a title="Add To Cart" href="#"><i className="pe-7s-cart"></i> Add to cart</a>
                                        </div>
                                        <div className="pro-same-action pro-quickview">
                                            <a title="Quick View" href="#" data-bs-toggle="modal" data-bs-target="#exampleModal"><i className="pe-7s-look"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="product-content text-center">
                                    <h3><a href="product-details.html">T- Shirt And Jeans</a></h3>
                                    <div className="product-rating">
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o"></i>
                                        <i className="fa fa-star-o"></i>
                                    </div>
                                    <div className="product-price">
                                        <span>$ 60.00</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-lg-4 col-sm-6">
                            <div className="product-wrap mb-25 scroll-zoom">
                                <div className="product-img">
                                    <a href="product-details.html">
                                        <img className="default-img" src="assets/img/product/pro-7.jpg" alt="" />
                                        <img className="hover-img" src="assets/img/product/pro-4-1.jpg" alt="" />
                                    </a>
                                    <span className="pink">-10%</span>
                                    <div className="product-action">
                                        <div className="pro-same-action pro-wishlist">
                                            <a title="Wishlist" href="#"><i className="pe-7s-like"></i></a>
                                        </div>
                                        <div className="pro-same-action pro-cart">
                                            <a title="Add To Cart" href="#"><i className="pe-7s-cart"></i> Add to cart</a>
                                        </div>
                                        <div className="pro-same-action pro-quickview">
                                            <a title="Quick View" href="#" data-bs-toggle="modal" data-bs-target="#exampleModal"><i className="pe-7s-look"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="product-content text-center">
                                    <h3><a href="product-details.html">T- Shirt And Jeans</a></h3>
                                    <div className="product-rating">
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o"></i>
                                        <i className="fa fa-star-o"></i>
                                    </div>
                                    <div className="product-price">
                                        <span>$ 60.00</span>
                                        <span className="old">$ 60.00</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-lg-4 col-sm-6">
                            <div className="product-wrap mb-25 scroll-zoom">
                                <div className="product-img">
                                    <a href="product-details.html">
                                        <img className="default-img" src="assets/img/product/pro-8.jpg" alt="" />
                                        <img className="hover-img" src="assets/img/product/pro-6.jpg" alt="" />
                                    </a>
                                    <span className="purple">New</span>
                                    <div className="product-action">
                                        <div className="pro-same-action pro-wishlist">
                                            <a title="Wishlist" href="#"><i className="pe-7s-like"></i></a>
                                        </div>
                                        <div className="pro-same-action pro-cart">
                                            <a title="Add To Cart" href="#"><i className="pe-7s-cart"></i> Add to cart</a>
                                        </div>
                                        <div className="pro-same-action pro-quickview">
                                            <a title="Quick View" href="#" data-bs-toggle="modal" data-bs-target="#exampleModal"><i className="pe-7s-look"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="product-content text-center">
                                    <h3><a href="product-details.html">T- Shirt And Jeans</a></h3>
                                    <div className="product-rating">
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o"></i>
                                        <i className="fa fa-star-o"></i>
                                    </div>
                                    <div className="product-price">
                                        <span>$ 60.00</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-6 col-lg-4 col-sm-6">
                            <div className="product-wrap mb-25 scroll-zoom">
                                <div className="product-img">
                                    <a href="product-details.html">
                                        <img className="default-img" src="assets/img/product/pro-1.jpg" alt="" />
                                        <img className="hover-img" src="assets/img/product/pro-1-1.jpg" alt="" />
                                    </a>
                                    <span className="pink">-10%</span>
                                    <div className="product-action">
                                        <div className="pro-same-action pro-wishlist">
                                            <a title="Wishlist" href="#"><i className="pe-7s-like"></i></a>
                                        </div>
                                        <div className="pro-same-action pro-cart">
                                            <a title="Add To Cart" href="#"><i className="pe-7s-cart"></i> Add to cart</a>
                                        </div>
                                        <div className="pro-same-action pro-quickview">
                                            <a title="Quick View" href="#" data-bs-toggle="modal" data-bs-target="#exampleModal"><i className="pe-7s-look"></i></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="product-content text-center">
                                    <h3><a href="product-details.html">T- Shirt And Jeans</a></h3>
                                    <div className="product-rating">
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o yellow"></i>
                                        <i className="fa fa-star-o"></i>
                                        <i className="fa fa-star-o"></i>
                                    </div>
                                    <div className="product-price">
                                        <span>$ 60.00</span>
                                        <span className="old">$ 60.00</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pro-pagination-style text-center mt-30">
                        <ul>
                            <li><a className="prev" href="#"><i className="fa fa-angle-double-left"></i></a></li>
                            <li><a className="active" href="#">1</a></li>
                            <li><a href="#">2</a></li>
                            <li><a className="next" href="#"><i className="fa fa-angle-double-right"></i></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    </>
  )
}

export default ShopFilterGrid
